// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.roam.wallet",
    name: "Roam",
    homepage: "https://roam.xyz",
    image_id: "a4500b0c-47e3-4c4a-207e-d72a57f1ca00",
    app: {
        browser: null,
        ios: "https://testflight.apple.com/join/hM8Ba1Qd",
        android: "https://google.com",
        mac: "https://google.com",
        windows: "https://google.com",
        linux: "https://google.com",
        chrome: "Roam.xyz",
        firefox: "https://google.com",
        safari: "https://google.com",
        edge: "https://google.com",
        opera: "https://google.com",
    },
    rdns: "xyz.roam.wallet",
    mobile: {
        native: "roam://",
        universal: null,
    },
    desktop: {
        native: "roam://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map